import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(
    private http: HttpClient
  ) { }

  apiUrl: string = `${environment.HOST}`;

  getTemplatesOptions(){
    return this.http.get(this.apiUrl + "/api/templates/list-names");
  }

  getInfoTemplateByName(id){
    return this.http.get(this.apiUrl + "/api/templates/detail/" + id);
  }

  sendTemplate(file: FormData){
    return this.http.post(this.apiUrl + "/api/templates/save", file);
  }

  sendTemplateInfo(info){
    return this.http.post("/api/test/template-file/info", info);
  }

  getTemplateVersions(page){
    return this.http.get(this.apiUrl + `/api/templates/list?page=${page - 1}&size=10`);
  }

}
